import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import moment from 'moment';
import ExcelReader from 'components/common/FileController/ExcelReader';
import { Modal, Table, Tooltip, Button, Descriptions, Popconfirm, Select, Input, notification, Pagination, Tag } from 'antd';

@inject(({ transStore }) => ({
  valCondition: transStore.valCondition,
  detailData: transStore.detailData,
  pageInfoUser: transStore.pageInfoUser,
  disOrderDetail: transStore.disOrderDetail,
  modOrderInfo: transStore.modOrderInfo,
  delOrderInfo: transStore.delOrderInfo,
}))
@observer
class TransDetailLgModal extends Component {
  state = {
    detailData: [],
    editingKey: null,
    editData: {},
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.detailData !== this.props.detailData) {
      this.setState({ detailData: nextProps.detailData, editingKey: null, editData: {} });
    }
  }

  onPageChange = (pageIdx) => {
    // console.log('page:', page);
    this.props.disOrderDetail(this.props.selectData, pageIdx);
  };

  save = async () => {
    const { editData } = this.state;
    // console.log("editData", editData);

    if (parseInt(editData.stCnt) < parseInt(editData.orCnt)) {
      notification.warning({placement: 'bottomLeft', message: `재고가 부족합니다.`, duration: 2});
      return false;
    }

    if (editData.orGdSize === '기타' && editData.orEtc === '') {
      notification.warning({placement: 'bottomLeft', message: process.env.REACT_APP_ETCSIZE, duration: 2});
      return false;
    }

    this.props.modOrderInfo([this.state.editData]);
    this.setState({ editingKey: null, editData: {}});
  };

  handleChange = (type, name, item, record, index) => {
    const { editData } = this.state;
    const funcChange = (valuNm, value, option) => {
      if (type === 'Select') {
        this.setState({
          editData:{
            ...editData,
            [valuNm]:value,
            stCnt: option,
          }
        });
      } else {
        this.setState({
          editData:{
            ...editData,
            [valuNm]:value,
          }
        });
      }
      // console.log("handleChange editData", editData);
    };
    if (type === 'Input') {
      return (
        <Input
          value={editData[name]}
          onChange={(e)=>funcChange(name, e.target.value)}
          style={{ width: '100%' }}
        />
      )
    } else if (type === 'Select') {
      return (
        <Fragment>
          <Select
            style={{ width: '100%' }}
            value={editData[name]}
            onChange={(value, option)=>funcChange(name, value, option.option.stCnt)}
          >
            {record.gdSizeList !== undefined && record.gdSizeList !== null &&
              record.gdSizeList.map(option=>{
              return(
                <Select.Option
                  disabled={option.stCnt === 0 ? true : false}
                  key={option.stSize}
                  option={option}
                >{option.stSize} 재고:{option.stCnt}</Select.Option>
              )
            })}
          </Select>
          {editData[name] === "기타" &&
          <Input
            placeholder={process.env.REACT_APP_ETCSIZE}
            value={editData.orEtc}
            onChange={(e)=>funcChange("orEtc", e.target.value)}
            style={{ width: '100%', marginTop: '5px' }}
          />
          }
        </Fragment>
      )
    }
  };

  render() {
    const {
      modalOpen,
      modalClose,
      selectData,
      valCondition,

      delOrderInfo,
      crudYn,
      ceType,
      cGbn,

      pageInfoUser
    } = this.props;
    const { detailData, editingKey } = this.state;
    const isEditing = record => record.RNUM === editingKey;
    // 유빈 - 로지텍이 아닐때
    const columns = [
      { title: 'No', dataIndex: 'RNUM', width: 70, align: 'center' },
      { title: '사번', dataIndex: 'orUserId', width: 120, align: 'center' },
      { title: '사원명', dataIndex: 'orUserNm', width: 150, align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {(item !== undefined && item !== null) 
              ? item 
              : (record.userNm !== undefined && record.userNm !== null) ? record.userNm : ""}
          </Fragment>
        )}
      },
      { title: '직무', dataIndex: 'orJobNm', width: 150, align: 'center' },
      { title: '성별', dataIndex: 'userSex', key: 'userSex', width: 80, align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {item === "M" && <Fragment>남</Fragment>}
            {item === "F" && <Fragment>여</Fragment>}
          </Fragment>
        )}
      },
      { title: '상품명', dataIndex: 'orGdNm', width: 250, align: 'center' },
      { title: '사이즈', dataIndex: 'orGdSize', width: 200, align: 'center',
        render: (item, record, index) => { 
          const editable = isEditing(record);
          return editable ? (
            this.handleChange('Select', 'orGdSize', item, record, index)
          ) : (
            item === "기타"
            ? <Tooltip placement="topLeft" title={record.orEtc}>
                <span style={{color: 'blue'}}>{item}</span>
              </Tooltip>
            : item
          )
        },
        editable: true
      },
      { title: '주문수량', dataIndex: 'orCnt', width: 100, align: 'center' },
      { title: '금액', dataIndex: 'orGdPrice', width: 130, align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {item !== undefined && item !== null && item !== '' &&
            (parseInt(item)*parseInt(record.orCnt)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </Fragment>
        )}
      },
      // { title: '신청사유', dataIndex: 'reqReason', width: 130, align: 'center',
      //   render: (item, record, index) => { 
      //     const editable = isEditing(record);
      //     return editable ? (
      //       this.handleChange('Input', 'reqReason', item, record, index)
      //     ) : (
      //       item !== undefined && item !== null && item !== "" &&
      //       <Tooltip placement="topLeft" title={record.reqReason}>
      //         <span style={{color: 'blue'}}>신청사유</span>
      //       </Tooltip>
      //     )
      //   },
      //   editable: true
      // },
      { title: '수정/삭제', dataIndex: '', width: 220, align: 'center', 
        render: (item, record, index) => {
          const editable = isEditing(record);
          return editable ? (
            <Fragment>
              <Button
                onClick={() => this.save()}
                style={{ marginRight: 8 }}
              >저장</Button>
              <Button 
                onClick={() =>{
                  this.setState({editingKey: null});
                }}
              >취소</Button>
            </Fragment>
          ) : (
            <Fragment>
              <Button
                disabled={editingKey !== null}
                style={{ marginRight: 8 }}
                onClick={() => this.setState({
                  editingKey: record.RNUM,
                  editData: {
                    ...record,
                    orGdCdOrg: record.orGdCd,
                    orGdSizeOrg: record.orGdSize,
                    orCntOrg: record.orCnt
                  }
                })}
              >수정</Button>
              <Popconfirm 
                title="삭제하시겠습니까?"
                onConfirm={()=>delOrderInfo(record)}
                onClick={(e)=>e.stopPropagation()}
              >
                <Button
                  disabled={editingKey !== null}
                >삭제</Button>
              </Popconfirm>
            </Fragment>
          );
        }
      },
    ];

    // 유빈 - 로지텍일때
    const columns2 = [
      { title: 'No', dataIndex: 'RNUM', width: 70, align: 'center' },
      { title: '센터', dataIndex: 'orCeNm', width: 180, align: 'center' },
      { title: '상품명', dataIndex: 'orGdNm', width: 250, align: 'center' },
      { title: '사이즈', dataIndex: 'orGdSize', width: 200, align: 'center',
        render: (item, record, index) => { 
          const editable = isEditing(record);
          return editable ? (
            this.handleChange('Select', 'orGdSize', item, record, index)
          ) : (
            item === "기타"
            ? <Tooltip placement="topLeft" title={record.orEtc}>
                <span style={{color: 'blue'}}>{item}</span>
              </Tooltip>
            : item
          )
        },
        editable: true
      },
      { title: '주문수량', dataIndex: 'orCnt', width: 100, align: 'center' },
      { title: '금액', dataIndex: 'orGdPrice', width: 130, align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {item !== undefined && item !== null && item !== '' &&
            (parseInt(item)*parseInt(record.orCnt)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </Fragment>
        )}
      },
      
    ];

    return (
      <Modal
        width={1300}
        title="주문상세보기"
        visible={modalOpen}
        onCancel={modalClose}
        footer={
          <Button
          type="primary"
            onClick={modalClose}
          >확인</Button>
        }
      > 
        <div>
          {/* 엑셀다운로드 */}
          <div className='buttonR'>
            <ExcelReader
              actionType={'download'}
              pageUrl={'DOWN-ORDER-DETAIL'}
              schInfo={{
                ...valCondition,
                ...this.props.selectData,
              }}
            />
          </div>
          <br />
          <div className="table_th_W">
            <Descriptions bordered>
              <Descriptions.Item label="주문일">
                {selectData !== null 
                && selectData.orDate !== undefined && selectData.orDate !== null
                && moment(selectData.orDate).format('YYYY-MM-DD')}
              </Descriptions.Item> 
              <Descriptions.Item label="주문번호" span={2}>
                {selectData !== null 
                && selectData.orCartNo !== undefined && selectData.orCartNo !== null
                && selectData.orCartNo}
                &nbsp;&nbsp;&nbsp;&nbsp;
                {selectData !== null && selectData.exceptionYn !== undefined && selectData.exceptionYn !== null && selectData.exceptionYn === "Y"
                && <Tag color="blue">기준외주문</Tag>}
              </Descriptions.Item>
              <Descriptions.Item label="상태">
                {selectData !== null 
                && selectData.orStat !== undefined && selectData.orStat !== null
                && <Fragment>
                    {selectData.orStat === "1" && <Fragment>승인대기</Fragment>}
                    {selectData.orStat === "2" && <Fragment>주문완료</Fragment>}
                    {selectData.orStat === "3" && <Fragment>승인반려</Fragment>}
                    {selectData.orStat === "4" && <Fragment>배송준비</Fragment>}
                    {selectData.orStat === "5" && <Fragment>배송중</Fragment>}
                    {selectData.orStat === "6" && <Fragment>구매확정</Fragment>}
                    {selectData.orStat === "7" && <Fragment>반품신청</Fragment>}
                    {selectData.orStat === "8" && <Fragment>반품승인</Fragment>}
                    {selectData.orStat === "9" && <Fragment>반품반려</Fragment>}
                    {selectData.orStat === "0" && <Fragment>주문취소</Fragment>}
                  </Fragment>}
              </Descriptions.Item>
              {(cGbn === process.env.REACT_APP_TYPE_COMPANY_SAMSUNG) &&
                <Fragment>
                  <Descriptions.Item label="지사" span={1}>
                    {selectData !== null 
                    && selectData.orBranchNm !== undefined && selectData.orBranchNm !== null
                    && selectData.orBranchNm}
                  </Descriptions.Item>
                  <Descriptions.Item label="센터" span={1}>
                    {selectData !== null 
                    && selectData.ceNm !== undefined && selectData.ceNm !== null
                    && selectData.ceNm}
                  </Descriptions.Item> 
                </Fragment>
              }
              
              <Descriptions.Item label="인수자" span={1}>
                {selectData !== null 
                && selectData.mgrUserId !== undefined && selectData.mgrUserId !== null
                && selectData.mgrUserId}
              </Descriptions.Item>
              <Descriptions.Item label="연락처" span={2}>
                {selectData !== null 
                && selectData.mgrHp !== undefined && selectData.mgrHp !== null
                && selectData.mgrHp}
              </Descriptions.Item>
              <Descriptions.Item label="우편번호" span={1}>
                {selectData !== null 
                && selectData.orZipCd !== undefined && selectData.orZipCd !== null
                && selectData.orZipCd}
              </Descriptions.Item>
              <Descriptions.Item label="배송지" span={2}>
                {selectData !== null 
                && selectData.orAddr !== undefined && selectData.orAddr !== null
                && selectData.orAddr}
              </Descriptions.Item>
              {selectData !== null 
                && selectData.rejectReason !== undefined && selectData.rejectReason !== null && selectData.orStat === "3" &&
                <Descriptions.Item label="반려사유" span={3}>
                  {selectData.rejectReason}
                </Descriptions.Item>
              }
            </Descriptions>
          </div>
          <div className="order_p_total">
            <div>총 <span className="num"> 
            {selectData !== null 
            && selectData.totalCnt !== undefined && selectData.totalCnt !== null
            && selectData.totalCnt}
            </span>건 </div>
            <div>총 주문액 <span className="num">{selectData !== null 
            && selectData.totalPrice !== undefined && selectData.totalPrice !== null
            && selectData.totalPrice !== ""
            && selectData.totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>원</div>
          </div>
        </div>
        <Table
          rowKey={(record)=>record.RNUM}
          rowClassName={(record)=>
            (record.orCnt !== undefined && record.orCnt !== null && parseInt(record.orCnt) < 0 && "red")
          }
          columns={
            cGbn === process.env.REACT_APP_TYPE_COMPANY_LGLOG ? columns
            : 
            ((selectData !== null 
              && selectData.orStat !== undefined && selectData.orStat !== null 
              && (selectData.orStat === "1" || selectData.orStat === "2" || selectData.orStat === "4")) && (crudYn === true) && (ceType === process.env.REACT_APP_TYPE_YUJIN))
            ? columns2 : columns2.slice(0, columns.length-1)
          } 
          dataSource={detailData} 
          scroll={{ x: 1470, y: 300 }}
          pagination={false}
        />
        <br />
        <div className="page_nav_ct">
          <Pagination
            showSizeChanger={false}
            current={pageInfoUser !== null ? pageInfoUser.pageIndex : 1}
            total={pageInfoUser !== null ? pageInfoUser.totalCnt : 0}
            pageSize={pageInfoUser !== null ? pageInfoUser.recordCountPerPage : 0}
            onChange={this.onPageChange}
          />
        </div>
      </Modal>
    );
  }

}

export default withRouter(TransDetailLgModal);